"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { TruncateTooltip } from "@/components/ui/truncate-tooltip";
import {
  type ArtifactAuthorProfile,
  artifactAuthorInitials,
} from "@/lib/artifacts/author-profiles";
import { cn } from "@/lib/utils";

type ArtifactAuthorProps = {
  author: ArtifactAuthorProfile;
  className?: string;
  avatarClassName?: string;
  nameClassName?: string;
};

/** Compact creator avatar and name for artifact list and detail metadata. */
export function ArtifactAuthor({
  author,
  className,
  avatarClassName,
  nameClassName,
}: ArtifactAuthorProps) {
  return (
    <span className={cn("inline-flex min-w-0 items-center gap-1.5", className)}>
      <Avatar
        className={cn(
          "size-5 shrink-0 border bg-muted text-[10px] text-muted-foreground",
          avatarClassName,
        )}
      >
        {author.picture ? (
          <AvatarImage alt={author.name} src={author.picture} />
        ) : null}
        <AvatarFallback className="text-[10px]">
          {artifactAuthorInitials(author.name)}
        </AvatarFallback>
      </Avatar>
      <TruncateTooltip>
        <span className={cn("min-w-0 truncate", nameClassName)}>
          {author.name}
        </span>
      </TruncateTooltip>
    </span>
  );
}
